module.exports = __webpack_public_path__ + "img/9788985403061.cbdd0993.jpg";